import { Navigate, Outlet, useParams } from "react-router-dom";

import { getPagePath, PAGES } from "@/config/pages";
import { isSupportedLanguage } from "@/i18n/routing";
import { useVolunteerAuthStore } from "@/stores/VolunteerAuthStore";

const VolunteerPublicRoute = () => {
  const { lang } = useParams<{ lang?: string }>();
  const { isAuthenticated } = useVolunteerAuthStore();

  if (isAuthenticated) {
    const dashboardPath = isSupportedLanguage(lang)
      ? getPagePath("volunteerDashboard", lang)
      : PAGES.volunteerDashboard;

    return <Navigate to={dashboardPath} replace />;
  }

  return <Outlet />;
};

export default VolunteerPublicRoute;
